import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class GridColumns {
  caption: string;
  dataField: string;
  width: number;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
  visible:boolean;
  format:string;
};
export class directadmission{
  StudentCourseID:number;
  StudentID:number;
  RegFormNo:number;
  CourseID:number;
  BranchID:number;
 //EntDepID:number;
  SeatNo:number;
  //EntCoScheduleID:number;
  Fees:number;
  CollegeID:number;
  RoundNo:number;
  AllotmentDate: string;
  JoiningDate:  string;
  AdmCatID:number;
  EntCenterID:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  CreatedDate:string;
UpdatedDate:string;

 /*  StudentName: string;
  StudentSexCode: string;
  StudentCount:number;
  CentreName: string;
  CourseCode: string;
  CourseName: string;
  CourseShortName: string;
  BranchCode: string;
  BranchName: string;
  CollegeCode: string;
  CollegeName: string;
  CollegeName2: string;
  RegFormNo:number;
  PRNNO: string;
  CenterName: string;
  CollegeName1: string;
  SocialReservationName: string;
  CasteCode: string;
  StudentMobileNo: string;
  StudentMailI: string;
  OnlinePaymentConfirmFlag: string;
  UTYStatus: string; */
  AllotmentFlag: string;
  DeleteFlag:string;
  RegConfirmFlag: string;
  DistrictID:number;
}
export class CETadmission{
  StudentCourseID:number;
  StudentID:number;
  RegFormNo:number;
  CourseID:number;
  BranchID:number;
  SeatNo:number;
  FeesAmount:number;
  Fees:number;
  CollegeID:number;
  RoundNo:number;
  AllotmentDate: string;
  JoiningDate:  string;
  AdmCatID:number;
  EntCenterID:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  CreatedDate:string;
  UpdatedDate:string;
  AllotmentFlag: string;
  DeleteFlag:string;
  RegConfirmFlag: string;
  DistrictID:number;
  ReceiptOrDDDate:string;
  ReceiptOrDDNo:number;
  EntPreStudentCollegeList: EntPreStudentCollegeList[]
  PurposeCode:number;
  AcademicInstanceID:number;
  OnLinePaymentConfirmFlag:string;
  merchantTxnNo:number;
  customerName:string;
  customerEmailId:string;
  customerMobileNo:string;
  customerID:string;
  PaymentFlag:string;
  payModeID:number;
  CoursePartID:number;
  ExamInstanceID:number;
  amount:number;
  PaymentType:String;
  AdmissionType:number;
  StudentType:string;
  //MediumID:number;
  PaymentString:string;
  StudentMobileNo:string;
  StudentMailID:string;
  StudentName:string;
  OnlinePaymentID:number;
  vendor_code1:string;
}
export class onlinepaymentList{
  merchantTxnNo:number;
}
export class EntPreStudentCollegeList{
  CollegeID :number;
}
let gridColumns: GridColumns[] = [
  /* {
    "caption": 'Fees',
    "dataField": "FeesAmount",
    "width":400,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true
  }, */
  {
    "caption": '',
    "dataField": "Type",
    "width":250,
    "dataType": "string",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    "format":""
  },
  {
    "caption": 'By Date',
    "dataField": "EndDate",
    "width":250,
    "dataType": "datetime",
    "cssClass": "text-left",
    "allowSorting": false,
    "visible":true,
    "format":"dd/MM/yyyy hh:mm"
  },
  {
    "caption": 'Open Category Fees',
    "dataField": "FeesAmount",
    "width":200,
    "dataType": "number",
    "cssClass": "text-right",
    "allowSorting": false,
    "visible":true,
    "format":""
  },
  {
    "caption": 'Category Fees',
    "dataField": "CategoryFeesAmount",
    "width":100,
    "dataType": "number",
    "cssClass": "text-right",
    "allowSorting": false,
    "visible":true,
    "format":""
  },
];

export class Fee {
  FeeID: number;
  FeeType: string;
  FeeDate: string;
  FeeAmount: number;
};

let cetFeeData: Fee[] = [
  {
    FeeID: 1,
    FeeType: 'Normal Fee',
    FeeDate: '05/04/2019 13:59',
    FeeAmount: 9000.00
  },
  {
    FeeID: 2,
    FeeType: 'Late Fee',
    FeeDate: '15/04/2019 13:59',
    FeeAmount: 9050.00
  },
  {
    FeeID: 3,
    FeeType: 'Super Late Fee',
    FeeDate: '25/04/2019 13:59',
    FeeAmount: 9500.00
  },
];

@Injectable({
  providedIn: 'root'
})
export class CetadmissionService {
  constructor(
    private dataService: DataAccessService) {
  }

  public getAllCenter(courseid,branchid) {debugger
    this.dataService.setControllerName = '/EntCenter/';
    this.dataService.setMethodName = 'GetEntranceCenterListByCourseIDANDBranchID?CourseID='+courseid+'&BranchID='+branchid+''; // setting method name from API controller.
    
    return this.dataService.getAll<CETadmission[]>()
  }
  public getOnlinePaymentData(StudentID,courseid,branchid,AcadamicInstanceID,PurposeCode) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPaymentDetails?StudentID='+StudentID+'&CourseID='+courseid+'&BranchID='+branchid+'&AcademicInstID='+AcadamicInstanceID+'&PurposeCode='+PurposeCode+''; // setting method name from API controller.
    
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetPaymentTranDetails(merchantTxnNo) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPaymentTranDetails?merchantTxnNo='+merchantTxnNo+''; // setting method name from API controller.
    return this.dataService.getAll<CETadmission[]>()
  }
  public CETAdmissionsave(data) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'PostInsertEntPreStudentCourseForCET'; // setting method name from API controller.
    return this.dataService.add<CETadmission[]>(data) 
  }

    public getStudentcategory(StudentID){
      this.dataService.setControllerName = '/PreStudentInformation/';
      this.dataService.setMethodName = 'GetPreStudentInformationList?StudentID='+StudentID; // setting method name from API controller.
      return this.dataService.getAll<CETadmission[]>()
    }
  public getPaymentTrxNo(StudentID,CourseID,CoursePartID,BranchID,AcadamicInstanceID,ExamInstanceID,PurposeCode,FeesAmount,EntCenterID,CollegeID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPutPaymentDetailTransactionNo?StudentID='+StudentID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcadamicInstanceID='+AcadamicInstanceID+'&ExamInstanceID='+ExamInstanceID+'&PurposeCode='+PurposeCode+'&FeesAmount='+FeesAmount+'&EntCenterID='+EntCenterID+'&CollegeID='+CollegeID + ''; 
    
    return this.dataService.getAll<CETadmission[]>()
  }
  public getPaymentTrxNoForProspect(StudentID,CourseID,CoursePartID,BranchID,AcadamicInstanceID,ExamInstanceID,PurposeCode,FeesAmount,EntCenterID,CollegeID,StuPoartlaID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPutPaymentDetailTransactionNoForProspectus?StudentID='+StudentID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcadamicInstanceID='+AcadamicInstanceID+'&ExamInstanceID='+ExamInstanceID+'&PurposeCode='+PurposeCode+'&FeesAmount='+FeesAmount+'&EntCenterID='+EntCenterID+'&CollegeID='+CollegeID + '&StuPoartlaID=' + StuPoartlaID + ''; 
    
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetPutPaymentDetailTransactionNoForHostel(StudentID,CourseID,CoursePartID,BranchID,AcadamicInstanceID,ExamInstanceID,PurposeCode,FeesAmount,CollegeID,HostelRegistrationID,HostelRegistrationPaymentID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPutPaymentDetailTransactionNoForHostel?StudentID='+StudentID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcadamicInstanceID='+AcadamicInstanceID+'&ExamInstanceID='+ExamInstanceID+'&PurposeCode='+PurposeCode+'&FeesAmount='+FeesAmount+'&CollegeID='+CollegeID + '&HostelRegistrationID=' + HostelRegistrationID + '&HostelRegistrationPaymentID='+ HostelRegistrationPaymentID + ''; 
    
    return this.dataService.getAll<CETadmission[]>()
  }
  public getPaymentTrxNoForAdmissionPayment(StudentID,CourseID,CoursePartID,BranchID,AcadamicInstanceID,ExamInstanceID,PurposeCode,FeesAmount,EntCenterID,CollegeID,ReservationCategoryID,PhysicalDisabilityID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPutPaymentDetailTransactionNo?StudentID='+StudentID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcadamicInstanceID='+AcadamicInstanceID+'&ExamInstanceID='+ExamInstanceID+'&PurposeCode='+PurposeCode+'&FeesAmount='+FeesAmount+'&EntCenterID='+EntCenterID+'&CollegeID='+CollegeID + '&ReservationCategoryID=' + ReservationCategoryID + '&PhysicalDisabilityID=' + PhysicalDisabilityID + ''; 
    
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetPutPaymentDetailTransactionNoForAdmissionPayment(StudentID,CourseID,CoursePartID,BranchID,AcadamicInstanceID,ExamInstanceID,PurposeCode,FeesAmount,EntCenterID,CollegeID,ReservationCategoryID,PhysicalDisabilityID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPutPaymentDetailTransactionNoForAdmissionPayment?StudentID='+StudentID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcadamicInstanceID='+AcadamicInstanceID+'&ExamInstanceID='+ExamInstanceID+'&PurposeCode='+PurposeCode+'&FeesAmount='+FeesAmount+'&EntCenterID='+EntCenterID+'&CollegeID='+CollegeID + '&ReservationCategoryID=' + ReservationCategoryID + '&PhysicalDisabilityID=' + PhysicalDisabilityID + ''; 
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetPutPaymentDetailTransactionNoForCommonOnlinePayment(AdmissionReceiptID,StudentID, AcadamicInstanceID,ExamInstanceID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetPutPaymentDetailTransactionNoForCommonOnlinePayment?AdmissionReceiptID='+ AdmissionReceiptID + '&StudentID='+StudentID+'&AcademicInstanceID='+AcadamicInstanceID+'&ExamInstanceID='+ExamInstanceID+''; 
    return this.dataService.getAll<CETadmission[]>()
  }
  public getUpdatePaymentStatusPreStudentExam(StudentID,merchantTxnNo,ExamInstanceID,CourseID,CoursePartID,BranchID) {debugger
    this.dataService.setControllerName = '/PreStudentExam/';
    this.dataService.setMethodName = 'getUpdatePaymentStatusPreStudentExam?StudentID='+StudentID+'&OnLinePaymentTransactionID='+ merchantTxnNo +'&ExamInstanceID='+ExamInstanceID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID;
    
    return this.dataService.getAll<CETadmission[]>()
  }
  
  public getUpdatePaymentStatusCETEnterance(StudentID,merchantTxnNo,AcademicInstanceID,CourseID,CoursePartID,BranchID,CollegeID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusCETEnterance?StudentID='+StudentID+'&merchantTxnNo='+ merchantTxnNo + '&AcademicInstanceID='+AcademicInstanceID+'&CourseID='+CourseID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID + '&CollegeID='+ CollegeID; // setting method name from API controller.
    
    return this.dataService.getAll<CETadmission[]>()
  }
  getColumns() {
    return gridColumns;
  }
  getCetFeeData() {
    return cetFeeData;
  }
  public GetCurrentCenter(courseid,branchid,StudentID,CollegeID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetCheckAlreadyPresent?CourseID=' + courseid + '&BranchID='+ branchid + '&StudentID='+StudentID+'&CollegeID='+CollegeID;
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetCurrentCenterForMerit(courseid,branchid,StudentID,AdmCatID,CollegeID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetCheckAlreadyPresentForPortal?CourseID=' + courseid + '&BranchID='+ branchid + '&StudentID='+StudentID+'&AdmCatID='+AdmCatID+'&CollegeID='+CollegeID;
    return this.dataService.getAll<CETadmission[]>()
  }
  
  public GetPrintRecieptCET(StudentID,AcademicInstanceID, CourseID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetPrintRecieptCET?StudentID=' + StudentID + '&AcademicInstanceID='+ AcademicInstanceID + '&CourseID='+CourseID+'';
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetPrintRecieptAdmissionPayment(StudentID,AcademicInstanceID, CourseID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetPrintRecieptAdmissionPayment?StudentID=' + StudentID + '&AcademicInstanceID='+ AcademicInstanceID + '&CourseID='+CourseID+'';
    return this.dataService.getAll<CETadmission[]>()
  }
  public GetUpdatePaymentTypeFromCET(StudentID, courseid, CoursePartID, BranchID, AcademicInstanceID,  ExamInstanceID) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'GetUpdatePaymentTypeFromCET?StudentID=' + StudentID + '&CourseID='+ courseid + '&CoursePartID='+CoursePartID+'&BranchID='+BranchID+'&AcademicInstanceID='+AcademicInstanceID+'&ExamInstanceID='+ExamInstanceID+'';
    return this.dataService.getAll<CETadmission[]>()
  }
}
